import { setVariable } from './utils.js';

// get height class ekit-popup-header and set variable.
export const getOffsetPopupHeaderHeight = ( element ) => {
	const popupHeader = element.querySelector( '.ekit-popup-header' );

	if (popupHeader) {
		const position = window.getComputedStyle( popupHeader ).getPropertyValue( 'position' );

		if (position === 'absolute' || position === 'fixed') {
			const popupHeaderHeight = popupHeader.offsetHeight;
			setVariable( element, '--thim-ekit-popup-header-height', popupHeaderHeight + 'px' );
		}

		if (elementorFrontend.isEditMode()) {
			elementor.channels.editor.on( 'change', function( view ) {
				// if popupHeader contain data-id value is view.container.id.
				if (popupHeader.dataset.id === view.container.id) {
					const changed = view.container.settings.changed;

					if (changed?.position === 'absolute' || changed?.position === 'fixed') {
						const popupHeaderHeight = popupHeader.offsetHeight;
						setVariable( element, '--thim-ekit-popup-header-height', popupHeaderHeight + 'px' );
					} else {
						setVariable( element, '--thim-ekit-popup-header-height', '0px' );
					}
				}
			} );
		}
	}
};

// get height class ekit-popup-footer and set variable.
export const getOffsetPopupFooterHeight = ( element ) => {
	const popupFooter = element.querySelector( '.ekit-popup-footer' );

	if (popupFooter) {
		const position = window.getComputedStyle( popupFooter ).getPropertyValue( 'position' );

		if (position === 'absolute' || position === 'fixed') {
			const popupFooterHeight = popupFooter.offsetHeight;
			setVariable( element, '--thim-ekit-popup-footer-height', popupFooterHeight + 'px' );
		}

		if (elementorFrontend.isEditMode()) {
			elementor.channels.editor.on( 'change', function( view ) {
				// if popupFooter contain data-id value is view.container.id.
				if (popupFooter.dataset.id === view.container.id) {
					const changed = view.container.settings.changed;

					if (changed?.position === 'absolute' || changed?.position === 'fixed') {
						const popupFooterHeight = popupFooter.offsetHeight;
						setVariable( element, '--thim-ekit-popup-footer-height', popupFooterHeight + 'px' );
					} else {
						setVariable( element, '--thim-ekit-popup-footer-height', '0px' );
					}
				}
			} );
		}
	}
};

export const stickySidebar = ( element ) => {
	// sticky sidebar use fixed position.
	const popupCourse = element.querySelector( '#popup-course' );

	if (popupCourse) {
		const stickySidebar = popupCourse.querySelector( '#ekit-sticky-sidebar' );

		if (stickySidebar) {
			const eConInner = stickySidebar.querySelector( '.e-con-inner' );
			const popupContentRight = popupCourse.querySelector( '.wrapper-popup-content-right' );

			if (eConInner && popupContentRight) {
				const setSticky = () => {
					// only run in desktop.
					if (window.innerWidth <= 1024) {
						return;
					}

					const popupCourseRect = popupCourse.getBoundingClientRect();
					const popupContentRightRect = popupContentRight.getBoundingClientRect();
					const widthSidebarItems = stickySidebar.offsetWidth + 'px';

					if (popupCourseRect.top <= 0 && popupContentRightRect.top <= 0) {
						eConInner.style.position = 'fixed';
						eConInner.style.top = '0';
						eConInner.style.left = stickySidebar.offsetLeft + 'px';
						eConInner.style.width = 'var(--thim-width-sidebar-items, ' + widthSidebarItems + ')';
					} else {
						eConInner.style.position = 'relative';
						eConInner.style.top = 'auto';
						eConInner.style.left = 'auto';
						eConInner.style.width = '100%';
					}
				};

				// when scroll, set eConInner fixed position.
				window.addEventListener( 'scroll', setSticky );

				// when window resize, set eConInner fixed position.
				window.addEventListener( 'resize', setSticky );
			}
		}
	}
};
